import React from 'react'
import { Box, FormControl, InputLabel, MenuItem, Select } from '@mui/material'
import { useAllPartnerNames } from 'shared/hooks/partners.hooks'

export interface AttributionSelectorProps {
  value: string
  onChange: (value: string) => void
}

/**
 * Select input for choosing attribution from available partners.
 * @param value - Selected attribution value
 * @param onChange - Callback invoked when selection changes
 */
export const AttributionSelector = ({
  value,
  onChange,
}: AttributionSelectorProps) => {
  const attributions = useAllPartnerNames() ?? []
  return (
    <Box width={150}>
      <FormControl fullWidth>
        <InputLabel id="attribution-selector-label">Attribution</InputLabel>
        <Select
          onChange={(e) => {
            onChange(e.target.value)
          }}
          value={value}
          id={'attribution-selector'}
          data-testid="attribution-selector"
          label={'Attribution'}
        >
          {attributions.map((attribution) => (
            <MenuItem
              key={`attribution-selector-${attribution}`}
              value={attribution}
            >
              {attribution}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  )
}
